import type { TransactionData } from '@shared/types';
import { invokeBackendRoute } from '@/backend/invoke';
import type { FinancialTransactionMutationResponse } from '@/backend/routes/transactions';

export const createFinancialTransaction = async (
  data: TransactionData & { idempotencyKey?: string },
): Promise<FinancialTransactionMutationResponse> =>
  await invokeBackendRoute<
    FinancialTransactionMutationResponse,
    TransactionData & { idempotencyKey?: string }
  >('createFirmTransaction', data);

export const updateFinancialTransaction = async (props: {
  data: Record<string, unknown>;
  transactionId: string;
}): Promise<FinancialTransactionMutationResponse> =>
  await invokeBackendRoute<
    FinancialTransactionMutationResponse,
    { data: Record<string, unknown>; transactionId: string }
  >('updateFirmTransaction', props);

export const failUnconsumedRetainerTransfer = async (
  transactionId: string,
): Promise<FinancialTransactionMutationResponse> =>
  await invokeBackendRoute<
    FinancialTransactionMutationResponse,
    { transactionId: string }
  >('failUnconsumedRetainerTransfer', { transactionId });

export const refreshUnconsumedRetainerTransfer = async (props: {
  data: Record<string, unknown>;
  transactionId: string;
}): Promise<FinancialTransactionMutationResponse> =>
  await invokeBackendRoute<
    FinancialTransactionMutationResponse,
    { data: Record<string, unknown>; transactionId: string }
  >('refreshUnconsumedRetainerTransfer', props);

export const deleteFinancialTransaction = async (
  transactionId: string,
): Promise<FinancialTransactionMutationResponse> =>
  await invokeBackendRoute<
    FinancialTransactionMutationResponse,
    { transactionId: string }
  >('deleteFirmTransaction', { transactionId });

export const unlinkFinancialInstitution = async (props: {
  deleteTransactions: boolean;
  financialInstitutionId: string;
  isFinalChunk: boolean;
  transactionIds: string[];
}): Promise<void> =>
  await invokeBackendRoute<
    void,
    {
      deleteTransactions: boolean;
      financialInstitutionId: string;
      isFinalChunk: boolean;
      transactionIds: string[];
    }
  >('unlinkFirmFinancialInstitution', props);
